interface BannerProps {
  title: string;
  description: string;
}

const Banner = ({ title, description }: BannerProps) => {
  return (
    <div className="bg-primary-600 text-white py-8 md:py-14 page-gutter xl:px-36">
      <div className="max-w-4xl md:text-justify">
        <h2 className={`text-lg text-white font-bold mb-2`}>{title}</h2>
        <p className="text-xs md:text-sm text-white leading-normal">{description}</p>
      </div>
    </div>
  );
}

export default Banner;
